<template>
<!-- 主页头部 -->
      <div>
         <span class="el-dropdown-link">
            <span style="margin-right:30px;font-size: 20px;color: #409EFF;">
            Hi!  {{username}}
            </span>
          </span>
        <el-button type="info" @click="logout">退出</el-button>
      </div>
</template>

<script>
export default {
    data() {
        return {
         userInfo: {
         phone: '',
         unionId: '',
         team: {
         name: ''
         }
      },
      username: ''
    }
  },
  methods: {
      logout () {
      this.$router.push('/login')
    }
  },
  created() {
    this.username = window.sessionStorage.getItem('username')
  }
}
</script>

<style lang="less" scoped>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
.el-icon-arrow-down {
    font-size: 12px;
  }

.el-header {
  background-color: #373d41;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  color: #ffffff;
  font-size: 20px;
  > div {
    display: flex;
    align-items: center;
    span {
      margin-left: 15px;
    }
  }
}
</style>
